<template>
  <div class="row">
    <div class="col-md-2"></div>
    <div class="col-md-8 mt-5" style="margin-bottom: 60px">
      <div class="main-card mb-3 card">
        <div class="card-body">
          <h4 class="mb-3">Startimes</h4>
          <form novalidate="" @submit.prevent="step == 0 ? requestSmartCard() : requestBankAccount()">
            <div class="form-row">
              <div class="col-md-12 mb-3">
                <label for="smartcard">Smartcard number</label>
                <input
                  type="number"
                  class="form-control"
                  id="smartcard"
                  placeholder="Smartcard number..."
                  required
                  min="1"
                  v-model="payload.reference"
                />
                <div class="invalid-feedback" :class="[invalid ? 'block' : '']">
                  Please provide a smartcard number.
                </div>
              </div>
            </div>
            <div class="form-row" v-if="step >= 1">
              <div class="col-md-12">
                <div class="alert alert-secondary fade show" role="alert">
                  <strong>Customer Name:</strong> {{ user.customer_name }}<br>
                  <strong>Smartcard number:</strong> {{ user.reference }}<br>
                  <strong>Network:</strong> {{ user.network }}<br>
                  <strong>Customer Address:</strong> {{ user.customer_address }}
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="email">Email address</label>
                  <input
                    type="email"
                    class="form-control"
                    id="email"
                    placeholder="Email address..."
                    required
                    v-model="provision.email"
                  />
                </div>
                <div class="form-group">
                  <label for="phone">Phone number</label>
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    placeholder="Phone number..."
                    required
                    v-model="provision.phone"
                  />
                </div>
              </div>
            </div>
            <div class="form-row" v-if="step == 2">
              <div class="col-md-12">
                <div class="alert alert-secondary fade show" role="alert">
                  <strong>Bank:</strong> {{ bank.bank }} <br>
                  <strong>Account number:</strong> {{ bank.account_number }}<br>
                  <strong>Account name:</strong> {{ bank.account_name }}
                </div>
              </div>
            </div>
            <div class="mb-3 progress" v-if="loading">
              <div class="progress-bar progress-bar-animated bg-danger progress-bar-striped" role="progressbar" aria-valuenow="100" aria-valuemin="0" aria-valuemax="100" style="width: 100%"></div>
            </div>
            <button class="btn btn-primary" type="button" @click.prevent="reset()" v-if="step !== 0" style="margin-right: 15px" :disabled="!loading ? false : true">{{ step === 1 ? 'Go back' : 'Reset' }}</button>
            <button class="btn btn-primary" type="submit" v-if="step !== 2" :disabled="!loading ? false : true">{{ step == 0 ? 'Submit' : 'Request bank account'}}</button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import APIService from "@/services/APIService";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["token"])
  },
  data () {
    return {
      invalid: false,
      payload: {
        action: 'validate',
        service: 'tv',
        network: 'StarTimes'
      },
      loading: false,
      step: 0,
      user: {},
      bank: {},
      provision: {
        action: 'provision',
        service: 'tv',
        network: 'StarTimes'
      }
    }
  },
  methods: {
    requestSmartCard() {
      if (this.validateCard()) {
        if (navigator.onLine) {
          this.invalid = false
          this.loading = true
          this.payload.token = this.token
          this.payload.passcode = this.hash(this.token)
          APIService.validate(this.payload)
            .then(response => {
              if (response.data.status === "0") {
                this.user = {
                  network: response.data.network,
                  reference: response.data.reference,
                  customer_name: response.data.customer_name,
                  customer_address: response.data.customer_address
                }
                this.step = 1
                this.loading = false
              } else {
                this.loading = false
                this.$fire({
                  title: response.data.message,
                  type: "error"
                });
              }
            })
            .catch(err => {
              this.loading = false;
              NProgress.done();
              if (err.response === undefined) {
                this.$fire("Oops! took long to get a response");
                NProgress.done();
              }
              this.$fire({
                title: err.response.statusText,
                text: err.response.data.message,
                type: "error"
              });
            });
        } else {
          this.$fire({
            title: "Network Error",
            text: "Please check your internet connection and try again",
            type: "error"
          });
        }
      } else {
        this.invalid = true
      }
    },
    requestBankAccount() {
      if (this.validateProvision()) {
        if (navigator.onLine) {
          this.loading = true
          this.provision.token = this.token
          this.provision.reference = this.payload.reference
          this.provision.passcode = this.hash(this.token)
          APIService.provision(this.provision)
            .then(response => {
              if (response.data.status === "0") {
                this.bank = {
                  bank: response.data.bank,
                  account_name: response.data.account_name,
                  account_number: response.data.account_number
                }
                this.step = 2
                this.loading = false
              } else {
                this.loading = false
                this.$fire({
                  title: response.data.message,
                  type: "error"
                });
              }
            })
            .catch(err => {
              this.loading = false;
              NProgress.done();
              if (err.response === undefined) {
                this.$fire("Oops! took long to get a response");
                NProgress.done();
              }
              this.$fire({
                title: err.response.statusText,
                text: err.response.data.message,
                type: "error"
              });
            });
        } else {
          this.$fire({
            title: "Network Error",
            text: "Please check your internet connection and try again",
            type: "error"
          });
        }
      }
    },
    reset () {
      this.loading = false
      this.payload.reference = null
      this.provision.email = null
      this.provision.phone = null
      this.step = 0
    },
    validateCard() {
      return this.payload.reference ? true : false
    },
    validateProvision() {
      if(this.provision.email) {
        if(this.provision.phone && this.provision.phone.length === 11) {
          return true
        } else {
          this.$fire({
            title: "Validation",
            text: "Phone number is required",
            type: "info"
          });
        }
      } else {
        this.$fire({
          title: "Validation",
          text: "Email is required",
          type: "info"
        });
      }
    },
    hash(ref) {
      const passcode = '12Cust0m34Sx'  
      let encrypted = this.$cryptoJS.HmacSHA512(ref, passcode)
      return encrypted.toString()
    }
  }
};
</script>
<style scoped>
.block {
  display: block;
}
.bg-danger {
  background-color: #ee7519 !important;
}
.small {
  font-size: 65%;
  font-weight: 200;
}
.main-card {
  margin-bottom: 30px;
}
</style>
